import { StdIndexInfo, StdInventoryIndex } from '@/appLogic/interfaces/inventory';
import { ISelectFormDataSet } from '@/coreDomainsModule/table';
import { calculateDataToDays, daysTocalculateDate } from './businessLogic';
/**
 *
 * @param stdIndexInfo
 */
const stdIndexInfoToStdInventoryIndex = (stdIndexInfo: StdIndexInfo): StdInventoryIndex => {
  const minFormSet: ISelectFormDataSet = { displayData: stdIndexInfo.min, selectedUnit: stdIndexInfo.unit };
  const maxFormSet: ISelectFormDataSet = { displayData: stdIndexInfo.max, selectedUnit: stdIndexInfo.unit };
  return { min: calculateDataToDays(minFormSet), max: calculateDataToDays(maxFormSet), option: { unit: stdIndexInfo.unit } };
};

/**
 * stdInventoryIndexを表示用のstdIndexInfoに変換する
 * @param stdInventoryIndices 対象の標準在庫指数
 * @returns 表示用の標準在庫指数情報
 */
const stdInventoryIndexToDisplayStdIndexInfo = (stdInventoryIndices: { [key: string]: StdInventoryIndex }): StdIndexInfo[] => {
  const stdIndexInfos: StdIndexInfo[] = [];
  for (const [name, value] of Object.entries(stdInventoryIndices)) {
    stdIndexInfos.push({ name: name, min: value.min, max: value.max, unit: value.option.unit });
  }
  return stdIndexInfos;
};

/**
 *
 * @param stdInventoryIndex
 * @param name
 */
const stdInventoryIndexToStdIndexInfo = (stdInventoryIndex: StdInventoryIndex, name: string): StdIndexInfo => {
  let unit = 'day';
  if (stdInventoryIndex?.option?.unit) {
    unit = stdInventoryIndex?.option?.unit;
  }
  const minFormSet = daysTocalculateDate(stdInventoryIndex.min, unit);
  const maxFormSet = daysTocalculateDate(stdInventoryIndex.max, unit);
  return { name: name, min: minFormSet.displayData || 0, max: maxFormSet.displayData || 0, unit: unit };
};

/**
 *
 */
const stdInventoryIndexObjectToStdIndexInfos = (stdInventoryIndices: { [key: string]: StdInventoryIndex }): StdIndexInfo[] => {
  const stdIndexInfos: StdIndexInfo[] = [];
  for (const [name, value] of Object.entries(stdInventoryIndices)) {
    stdIndexInfos.push(stdInventoryIndexToStdIndexInfo(value, name));
  }
  return stdIndexInfos;
};

/**
 *
 * @param stdIndexInfos
 */
const stdIndexInfosToStdInventoryIndexObject = (stdIndexInfos: StdIndexInfo[]): { [key: string]: StdInventoryIndex } => {
  const stdInventoryIndexObject: { [key: string]: StdInventoryIndex } = {};
  for (const stdIndexInfo of stdIndexInfos) {
    stdInventoryIndexObject[stdIndexInfo.name] = stdIndexInfoToStdInventoryIndex(stdIndexInfo);
  }
  return stdInventoryIndexObject;
};

export {
  stdIndexInfoToStdInventoryIndex,
  stdInventoryIndexToDisplayStdIndexInfo,
  stdInventoryIndexToStdIndexInfo,
  stdInventoryIndexObjectToStdIndexInfos,
  stdIndexInfosToStdInventoryIndexObject,
};
